import dynamic from 'next/dynamic';

const TradeTicketsContent = dynamic(() =>
  import('./TradeTicketsContent/TradeTicketsContent')
);
const TradeTicketForm = dynamic(() =>
  import('./TradeTicketForm/TradeTicketForm')
);
const TradeTicketDetails = dynamic(() =>
  import('./TradeTicketDetails/TradeTicketDetails')
);
const TradeTicketUserDetails = dynamic(() =>
  import('./TradeTicketUserDetails/TradeTicketUserDetails')
);
const TradeTicketsFilters = dynamic(() =>
  import('./TradeTicketsFilters/TradeTicketsFilters')
);
const TradeTicketSendEmailsModal = dynamic(() =>
  import('./TradeTicketSendEmailsModal/TradeTicketSendEmailsModal')
);

export {
  TradeTicketsContent,
  TradeTicketForm,
  TradeTicketDetails,
  TradeTicketUserDetails,
  TradeTicketsFilters,
  TradeTicketSendEmailsModal,
};
